export default __webpack_public_path__ + "static/media/headerbar.ce070ada.jpg";